<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMomMaterialDrawingInfoResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      with-custom-row-actions-first-column
                                      header-btn-add-disabled headerBtnEditDisabled
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                                      @linkClick="whenLinkClick">
                                <template #left-header>
                                    <b-button variant="outline-primary" :disabled="$_notChecked"
                                              @click="batchDownloadDrawing">
                                        <i class="fa-solid fa-file-zipper"></i> 下载图纸
                                    </b-button>
                                </template>
                                <template #right-header>
                                    <b-button variant="outline-primary" @click="openUriDownload">
                                        <i class="fa-solid fa-link"></i> URI下载测试
                                    </b-button>
                                </template>
                                <template #customRowActionsFirstColumn="{row}">
                                    <b-button-group>
                                        <template v-if="!hasCode(row.attachmentId)">
                                            <em-button type="downloadFile"
                                                       :busy="requestNewLoading&&requestNewId===row.id"
                                                       :disabled="requestNewLoading"
                                                       custom-label="请求SAP工程图"
                                                       custom-icon="fa fa-solid fa-cloud-arrow-down"
                                                       class="btn btn-outline-primary btn-sm"
                                                       @click="requestNew(row.id)">
                                            </em-button>
                                            <em-button type="downloadFile"
                                                       custom-label="手动补传"
                                                       custom-icon="fa fa-solid fa-file-arrow-up"
                                                       class="btn btn-outline-primary btn-sm"
                                                       @click="openUpload(row.id)">
                                            </em-button>
                                        </template>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

        <re-b-modal ref="upload" header="手动补传">
            <file-upload :action="action" :accept="accept" @success="uploadSuccess"></file-upload>
        </re-b-modal>

        <re-b-modal ref="uriDownload" header="URI 下载测试"
                    no-auto-hide no-ok-button
                    @hide="resetUriDiag">
            <b-form-group label="URI" label-cols="3">
                <b-form-input v-model="uriInput"
                              placeholder="请输入文件 URI"
                              trim></b-form-input>
            </b-form-group>
            <b-form-group label="文件名" label-cols="3">
                <b-form-input v-model="filenameInput"
                              placeholder="请输入文件名（含扩展名）"
                              trim></b-form-input>
            </b-form-group>
            <div class="d-flex justify-content-end mb-2">
                <b-button variant="primary"
                          :disabled="uriDiagTesting"
                          @click="testUri">
                    <b-spinner v-if="uriDiagTesting" small></b-spinner>
                    测试
                </b-button>
            </div>
            <b-alert v-if="uriDiagResult" :variant="uriDiagResult.variant" show class="mb-2">
                <div><b>{{ uriDiagResult.title }}</b></div>
                <div v-if="uriDiagResult.detail" class="small mt-1">{{ uriDiagResult.detail }}</div>
                <div v-if="uriDiagResult.canSave" class="mt-2">
                    <b-button size="sm" variant="outline-success" @click="saveDiagBlob">
                        <i class="fa-solid fa-floppy-disk"></i> 保存到本地
                    </b-button>
                </div>
            </b-alert>
        </re-b-modal>

        <re-b-modal ref="downloadTimes" header="下载记录"
                    hide-footer
                    @hide="recordShow=false">
            <div class="d-flex flex-column h-100 position-relative">
                <mini-table ref="downloadRecordTable"
                            class="flex-grow-1 overflow-auto"
                            :items="downloadRecords"
                            entity-name="sithMomMaterialDrawingDownloadRecord"
                            :custom-vuex-name="viewRecordSummary?'summaryMode':'recordMode'"
                            read-only
                            need-model-fields>
                    <template #leftHeader>
                        <b-form-checkbox v-model="viewRecordSummary" name="check-button" switch>
                            统计模式：<b>{{ viewRecordSummary ? '开启' : '关闭' }}</b>
                        </b-form-checkbox>
                    </template>
                </mini-table>
                <div style="min-height: 200px"></div>
                <table-chart-viewer style="height: 200px !important;"
                                    class="position-absolute bottom"
                                    v-if="recordShow"
                                    :rows="downloadRecords"
                                    :options="recordChartOptions"></table-chart-viewer>
            </div>
        </re-b-modal>
    </div>
</template>
<script>
// Author liang gang qiang
// Date 2023-09-06 09:52:43

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import FileUpload from "@/components/common/inputs/FileUpload.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import TableChartViewer from "@/components/echarts-part/TableChart/cell/TableChartViewer.vue";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import drawingDownloadMixin from "@/views/sithMesII/pds/stuffs/drawing-download-mixin";

export default {
    name: "sithMomMaterialDrawingInfoListView",
    components: {TableChartViewer, MiniTable, FileUpload, ReBModal},
    mixins: [emCommonListMixin, emCustomVuexMixin, emCommonUtilMixin, emTableCheckedMixin, drawingDownloadMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            requestNewLoading: false,
            requestNewId: null,
            accept: '.pdf,.jt,.xls,.xlsx,.doc,.docx',

            selectedRow: null,
            downloadRecords: [],
            viewRecordSummary: true,
            recordShow: false,

            uriInput: '',
            filenameInput: '',
            uriDiagTesting: false,
            uriDiagResult: null,
            uriDiagBlob: null,
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        action() {
            return process.env.VUE_APP_SITHMES_II_URL + "/materialDrawing/upload/byUser?drawingId=" + this.requestNewId;
        },
        recordChartOptions() {
            return this.viewRecordSummary ?
                {
                    list: [{
                        key: '__sum',
                        item: {
                            label: '下载次数',
                            key: 'downloadTimes',
                        },
                        type: 'pie',
                        aggregation: 'SUM'
                    }],
                    xAxisFields: [{
                        key: 'downloadUserName',
                        form: {
                            type: 'input'
                        },
                    }]
                }
                :
                {
                    list: [{
                        key: '__count',
                        item: {
                            label: '下载次数',
                            isCountSum: true,
                            isAppend: true
                        },
                        type: 'bar',
                        aggregation: 'SUM'
                    }],
                    xAxisFields: [{
                        key: 'createdTime',
                        form: {
                            type: 'datetimepicker'
                        },
                    }],
                    dateSplitUnit: 3
                }
        },
    },
    watch: {
        viewRecordSummary() {
            this.queryDownloadRecords();
        },
    },
    mounted() {
        let material = this.$route.query.material;
        if (material) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('materialFilter', material);
            this.$refs.emListFilter.doQuery();
        }
    },
    methods: {
        requestNew(id) {
            this.requestNewLoading = true;
            this.requestNewId = id;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_II_URL + "/materialDrawing/request/retry?drawingId=" + id,
                data: {}
            }).then(() => {
                this.$message.success("request success");
            }).finally(() => this.requestNewLoading = false);
        },
        openUpload(id) {
            this.requestNewId = id;
            this.$refs.upload.showModal();
        },
        uploadSuccess() {
            this.$message.success('upload success');
            this.$refs.upload.hide();
            this.$refs.emListFilter.doQuery();
        },
        whenLinkClick(key, row) {
            if (key === 'originFileName') {
                if (this.hasCode(row.attachmentId)) {
                    this.downloadDrawing(row.id, row[key]);
                } else {
                    this.$message.error("文件不存在")
                }
            } else if (key === 'downloadTimes') {
                this.selectedRow = row;
                this.$refs.downloadTimes.showModal();
                this.queryDownloadRecords();
            }
        },

        queryDownloadRecords() {
            if (this.selectedRow) {
                this.$refs.downloadTimes.changeLoading(true);
                let url = `${process.env.VUE_APP_SITHMES_II_URL}/sithMomMaterialDrawingDownloadRecord/record/byDrawingId`;
                if (this.viewRecordSummary) {
                    url += '/summary';
                }
                this.$store.dispatch('api/get', {
                    url: url += '?drawingId=' + this.selectedRow.id
                }).then(response => {
                    this.downloadRecords = response;
                    this.recordShow = true;
                }).finally(() => this.$refs.downloadTimes.changeLoading(false));
            }
        },

        batchDownloadDrawing() {
            if (this.downloadLoading) {
                this.$message.warning("请等待上一个下载完成");
                return;
            }
            let fileName = '';
            let length = this.checkedRows.length;
            if (length > 0) {
                fileName += this.checkedRows[0].material;
            } else {
                return;
            }
            if (length > 1) {
                fileName += '...';
            }
            fileName += '(共' + length + '个文件).zip'
            this.downloadLoading = true;
            this.$message.info("下载中...");
            let url = process.env.VUE_APP_SITHMES_II_URL + "/materialDrawing/download/batch?drawingIds=" + this.selectIds;
            this.downloadWithHeader(url, fileName, () => this.downloadLoading = false);
        },

        openUriDownload() {
            this.resetUriDiag();
            this.uriInput = '';
            this.filenameInput = '';
            this.$refs.uriDownload.showModal();
        },
        resetUriDiag() {
            this.uriDiagTesting = false;
            this.uriDiagResult = null;
            this.uriDiagBlob = null;
        },
        async testUri() {
            const uri = (this.uriInput || '').trim();
            const fileName = (this.filenameInput || '').trim();
            if (!uri || !fileName) {
                this.$message.warning("请填写 URI 与文件名");
                return;
            }
            this.uriDiagTesting = true;
            this.uriDiagResult = null;
            this.uriDiagBlob = null;
            const url = process.env.VUE_APP_SITHMES_II_URL
                + "/materialDrawing/download/byUri"
                + "?uri=" + encodeURIComponent(uri)
                + "&fileName=" + encodeURIComponent(fileName);
            try {
                const res = await fetch(url, {
                    method: 'GET',
                    headers: {Authorization: localStorage['em_sso_token']},
                });
                if (!res.ok) {
                    let detail = `HTTP ${res.status}`;
                    try {
                        const ct = res.headers.get('Content-Type') || '';
                        if (ct.includes('json')) {
                            const json = await res.json();
                            if (json && json.message) {
                                detail += ' — ' + json.message;
                            }
                        }
                    } catch (_) {
                        // ignore body-parse error
                    }
                    if (res.status === 400) {
                        detail += '。URI 域名可能未在 HOST_MAP_IP 字典中映射。';
                    }
                    this.uriDiagResult = {
                        variant: 'danger',
                        title: '❌ 服务端错误，URI 不可用',
                        detail,
                        canSave: false,
                    };
                    return;
                }
                const blob = await res.blob();
                if (blob.size === 0) {
                    this.uriDiagResult = {
                        variant: 'warning',
                        title: '⚠️ 返回空文件，URI 不可用',
                        detail: '后端响应 200，但 body 为 0 字节，远端可能没有返回内容。',
                        canSave: false,
                    };
                    return;
                }
                this.uriDiagBlob = blob;
                this.uriDiagResult = {
                    variant: 'success',
                    title: '✅ URI 可用',
                    detail: `已取回 ${blob.size} 字节。`,
                    canSave: true,
                };
            } catch (e) {
                this.uriDiagResult = {
                    variant: 'danger',
                    title: '❌ 请求层错误',
                    detail: (e && e.message) ? e.message : String(e),
                    canSave: false,
                };
            } finally {
                this.uriDiagTesting = false;
            }
        },
        saveDiagBlob() {
            if (!this.uriDiagBlob) return;
            const fileName = (this.filenameInput || '').trim() || 'download';
            const blobUrl = window.URL.createObjectURL(this.uriDiagBlob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.setAttribute('download', fileName);
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(blobUrl);
        },
    }
};
</script>

<style scoped>
::v-deep .custom-control-label {
    width: max-content !important;
}
</style>
